import {KanbanUser} from '../types/KanbanUser';

export const getNonHiddenSelectedUserIds = (selectedUsers: KanbanUser[]) =>
  selectedUsers.filter((user) => user.id && !user.isHidden).map((user) => user.id);
